import { render, staticRenderFns } from "./WorkerShiftInfoForm.vue?vue&type=template&id=2489d0ab&scoped=true&"
import script from "./WorkerShiftInfoForm.vue?vue&type=script&lang=js&"
export * from "./WorkerShiftInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkerShiftInfoForm.vue?vue&type=style&index=0&id=2489d0ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2489d0ab",
  null
  
)

export default component.exports